import { axiosClient } from "@/api/axios";

export function getByUserId(userId, query) {
  return axiosClient.get(`documentation/users/${userId}`, query);
}

export function preSignedUrl(fileId) {
  return axiosClient.get(`documentation/${fileId}/pre-signed-url`);
}
